import { useQuery } from "@tanstack/react-query";

import { getClubDashboard } from "@/app/api/dynabuy-back/api-club";

interface UseClubDashboardQueryParams {
  clubSlug: string | undefined;
  enabled?: boolean;
}

export const useClubDashboardQuery = ({
  clubSlug,
  enabled = true,
}: UseClubDashboardQueryParams) => {
  return useQuery({
    queryKey: ["clubDashboard", clubSlug],
    queryFn: () => getClubDashboard(clubSlug),
    enabled: enabled && !!clubSlug,
  });
};
